import noUiSlider from 'nouislider';

window.addEventListener('load', () => {
  const sliderEl = document.getElementById('price-slider');
  const inputMin = document.getElementById('min_price');
  const inputMax = document.getElementById('max_price');

  if (!sliderEl || !inputMin || !inputMax) return;

  const startMinPrice = inputMin.value
    ? parseInt(inputMin.value, 10)
    : parseInt(sliderEl.dataset.priceSliderStartMin, 10);
  const startMaxPrice = inputMax.value
    ? parseInt(inputMax.value, 10)
    : parseInt(sliderEl.dataset.priceSliderStartMax, 10);
  const rangeMin = parseInt(sliderEl.dataset.priceSliderRangeMin, 10);
  const rangeMax = parseInt(sliderEl.dataset.priceSliderRangeMax, 10);
  const step = parseInt(sliderEl.dataset.priceSliderStep, 10);

  noUiSlider.create(sliderEl, {
    start: [startMinPrice, startMaxPrice],
    connect: true,
    range: { min: rangeMin, max: rangeMax },
    step: step,
    margin: 50,
  });

  sliderEl.noUiSlider.on('update', (values, handle) => {
    const [min, max] = values.map((val) => Math.round(val));
    inputMin.value = min;
    inputMax.value = max;
  });

  inputMin.addEventListener('change', () => {
    sliderEl.noUiSlider.set([parseInt(inputMin.value, 10), parseInt(inputMax.value, 10)]);
  });

  inputMax.addEventListener('change', () => {
    sliderEl.noUiSlider.set([parseInt(inputMin.value, 10), parseInt(inputMax.value, 10)]);
  });

  setTimeout(() => {
    sliderEl.noUiSlider?.updateOptions({}, true);
    sliderEl.noUiSlider.on('set', (values, handle) => {
      jQuery(inputMin).trigger('input');
    });
  }, 50);
});
